import { db } from '../../config/main_config';
import { ControlReferenceMSG as ControlReference } from "../../../../interfaces/controlReference.msg.interface";
/**
 * Fetches control references from Firestore based on the page name and a path array.
 * @param pageName - The name of the page document.
 * @param pathArray - An array of keys to traverse the document data.
 * @returns A promise that resolves to an array of ControlReference objects or null if not found.
 */
export async function getControlReferences(pageName: string, pathArray: string[]): Promise<ControlReference[] | null> {
    try {
        // Reference to the Firestore document
        const docRef = db
            .collection('ManagementSystemGuide')
            .doc('defaults')
            .collection('pages')
            .doc(pageName);
        const doc = await docRef.get();

        if (!doc.exists) {
            console.error('No such document!');
            return null;
        }

        let data: any = doc.data();

        // Traverse the data using the keys in pathArray
        for (const key of pathArray) {
            if (data && Object.prototype.hasOwnProperty.call(data, key)) {
                data = data[key];
                console.log('[getControlReferences]', data)
            } else {
                console.error(`Path not found: ${key}`);
                return null;
            }
        }

        // Retrieve the 'controlReferences' field at the end of the path
        if (data && Array.isArray(data['controlReferences'])) {
            // Optionally, validate each control reference object
            const controlRefs: ControlReference[] = data['controlReferences'].map((ref: any) => ({
                controlID: ref.controlID,
                frameworks: ref.frameworks,
                ref: ref.ref,
                text: ref.text
            }));
            return controlRefs;
        } else {
            console.error('No controlReferences field at the end of the path or it is not an array');
            return null;
        }
    } catch (error: any) {
        console.error('Error getting document:', error.message || error);
        return null;
    }
}
